export default __webpack_public_path__ + "static/media/telegram.cc8b942b.png";